import * as React from 'react'
import { useSiteMetadata } from '../../queries/site-medatata';
import TelerikLayout from './telerik-layout';
import SitefinityLayout from './sitefinity-layout';
import '../../styles/global.scss'

const Layout = (props) => {
    const metadata = useSiteMetadata();

    switch (metadata.template) {
        case 'telerik':
            return <TelerikLayout {...props} />
        case 'sitefinity':
            return <SitefinityLayout {...props} />
        default:
            throw new Error(`Unknown template type: ${metadata.template}`);
    }
}

export default Layout;